import { IViewpoint } from "@inweb/viewer-core";

import { OdBaseDragger } from "../Draggers/Common/OdBaseDragger";
import { Viewer } from "../Viewer";
import { IMarkupObject } from "./Api/IMarkupObject";

export enum MarkupType {
  Unknown,
  Konva = "Konva",
  Visualize = "Visualize",
}

export enum MarkupMode {
  Line = "Line",
  Text = "Text",
  Rectangle = "Rectangle",
  Ellipse = "Ellipse",
  Arrow = "Arrow",
  Image = "Image",
  Cloud = "Cloud",
}

export interface IMarkup {
  lineWidth: number;

  initialize(viewer: Viewer, canvas: HTMLCanvasElement, canvasEvents: string[]): void;
  dispose(): void;

  getDraggers(): Map<string, typeof OdBaseDragger>;
  clearOverlay(): void;
  setMarkupColor(r: number, g: number, b: number): void;
  getMarkupColor(): { r: number; g: number; b: number };
  colorizeAllMarkup(r: number, g: number, b: number): void;
  colorizeSelectedMarkups(r: number, g: number, b: number): void;
  setViewpoint(viewpoint: IViewpoint): void;
  getViewpoint(): IViewpoint;

  createObject(type: string, params: any): IMarkupObject;
  getObjects(): IMarkupObject[];
  getSelectedObjects(): IMarkupObject[];
  selectObjects(objects: IMarkupObject[]): void;
  clearSelected(): void;
}
